import { render, staticRenderFns } from "./driver-selected-data.vue?vue&type=template&id=15cd00d8&scoped=true"
import script from "./driver-selected-data.vue?vue&type=script&lang=js"
export * from "./driver-selected-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd00d8",
  null
  
)

export default component.exports